export default __webpack_public_path__ + "62e9a0733983c1ab826e5db096d1a59e.gif";